// import React from "react";
import { GoPerson } from "react-icons/go";
import { FaVideo } from "react-icons/fa6";
import { TfiThought } from "react-icons/tfi";
import { GrWaypoint } from "react-icons/gr";

import "./index.css";
import RequestCallButton from "../CallReqButton";
const features = [
  {
    icon: <GoPerson />,
    title: "1-on-1 Mentorship",
    description:
      "Personalized guidance from industry experts with 10+ years of experience",
  },
  {
    icon: <FaVideo />,
    title: "Live Doubt Sessions",
    description:
      "Weekly live sessions to clear doubts and get expert advice on projects",
  },
  {
    icon: <TfiThought />,
    title: "Community Support",
    description:
      "Active community of learners and mentors for continuous learning support",
  },
  {
    icon: <GrWaypoint />,
    title: "Career Guidance",
    description:
      "Resume reviews, interview preparation, and career roadmap planning",
  },
];

// const stats = [
//   {
//     value: "200+",
//     label: "Expert Mentors",
//     sub: "From top companies",
//     color: "#9333ea",
//   },
//   {
//     value: "12+",
//     label: "Avg. Experience",
//     sub: "Years in industry",
//     color: "#2563eb",
//   },
//   {
//     value: "5000+",
//     label: "Students Mentored",
//     sub: "Success stories",
//     color: "#16a34a",
//   },
//   {
//     value: "24/7",
//     label: "Support Available",
//     sub: "Round the clock",
//     color: "#be185d",
//   },
// ];

const FounderSection = () => {
  // const team = () => {
  //   return (
  //     <div className="team-bg-container">
  //       <div className="container">
  //         <h2
  //           className="text-center mentor-heading"
  //           style={{ fontWeight: "bold" }}
  //         >
  //           Meet Our Expert Mentors
  //         </h2>
  //         <div className="row">
  //           <div className="col-12 col-lg-4">
  //             <div className="team-member-card">
  //               <img
  //                 src="https://iqteche.in/static/media/wl_client_images/dab1a01bbaed495c9c655d7baff5bfd4.webp"
  //                 alt=""
  //                 className="team-member-img"
  //               />
  //               <h2>RajKumar</h2>
  //               <p>Ex: Google</p>
  //             </div>
  //           </div>

  //           <div className="col-12 col-lg-4">
  //             <div className="team-member-card">
  //               <img
  //                 src="https://iqteche.in/static/media/wl_client_images/dab1a01bbaed495c9c655d7baff5bfd4.webp"
  //                 alt=""
  //                 className="team-member-img"
  //               />
  //               <h2>Fariyad</h2>
  //               <p>Ex: Google</p>
  //             </div>
  //           </div>

  //           <div className="col-12 col-lg-4">
  //             <div className="team-member-card">
  //               <img
  //                 src="https://iqteche.in/static/media/wl_client_images/e3d309657699483aa360d018943f97b7.jpg"
  //                 alt=""
  //                 className="team-member-img"
  //               />
  //               <h2>Abdul Kareem</h2>
  //               <p>Ex: Google</p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const MentorshipSection = () => {
    return (
      <section className="mentorship-section">
        {/* {team()} */}
        <h1>Our Support For Learners</h1>
        <div className="features ">
          {features.map((f, idx) => (
            <div
              className="feature-card d-flex flex-column align-items-center justify-content-center"
              key={idx}
            >
              <div className="feature-icon d-flex flex-column justify-content-center align-items-center">
                {f.icon}
              </div>
              <h3>{f.title}</h3>
              <p>{f.description}</p>
            </div>
          ))}
        </div>

        {/* <div className="stats">
          {stats.map((s, idx) => (
            <div className="stat-card" key={idx}>
              <h2 style={{ color: s.color }}>{s.value}</h2>
              <h4>{s.label}</h4>
              <p>{s.sub}</p>
            </div>
          ))}
        </div> */}
      </section>
    );
  };

  return (
    <section className="founder">
      <div className="founder-container pb-5">
        <div className="founder-image-cont d-none d-lg-block">
          <img
            src="https://res.cloudinary.com/dyvxdlyrr/image/upload/v1750312109/Founder_Image_pdqxdz.png"
            alt="Founder of IBIX"
            className="founder-img"
          />
        </div>

        <div className="founder-content">
          <h2>Empowering the Next Generation of Innovators</h2>
          <div className="founder-image-cont  d-lg-none">
            <img
              src="https://res.cloudinary.com/dyvxdlyrr/image/upload/v1750312109/Founder_Image_pdqxdz.png"
              alt="Founder of IBIX"
              className="founder-img"
            />
          </div>
          <p className="quote">
            “At IBIX, we believe every student has the potential to lead and
            innovate. We offer hands-on training in AI, ML, Data Science,
            Cybersecurity, and more. Our expert-led programs build skills and
            confidence. Your journey to success starts here — and we're proud to
            be part of it.”
          </p>

          <h3 className="founder-name">
            Jelani Basha <span className="founder-tag">(Ex-NRI)</span>
          </h3>
          <p className="founder-role">
            {" "}
            <strong>Founder & CEO of IBIX Qodify Technologies</strong>
          </p>
        </div>
      </div>
      {MentorshipSection()}

      <RequestCallButton />
    </section>
  );
};

export default FounderSection;
